(function() {

    const DEV_ID = 'G-RL9Y26WNW2';
    const PROD_ID = 'G-RRP8K4M4F3';

    const ENV_PROD = 'prod';
    
    const getId = () => {
      const environment = window.twilio.environment || ENV_DEV;
      switch (environment) {
          case ENV_PROD:
              return PROD_ID;
          default:
              return DEV_ID;
      }
    }

    /*-- Global site tag (gtag.js) - Google Analytics */
    var script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id="+getId();
    script.type = "text/javascript";
    script.async = true;
    script.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', getId());
    }
    document.head.appendChild(script);
})()



// WEBPACK FOOTER //
// ./src/js/gtag.js